import { FlexLayout, Input } from '@deity-io/portal-ui';
import StructurePicker from 'components/FieldEditorControls/StructurePicker';
import type { CreateMappingInput } from 'components/Mappings/CreateMappingModal';
import type { FormikErrors } from 'formik';
import type { FC } from 'react';

interface FormFieldProps {
  errors: FormikErrors<CreateMappingInput>;
  values: CreateMappingInput;
  packageVersionUuid: string;
  setFieldValue: (field: string, value: any) => void;
  setFieldTouched: (field: string, isTouched?: boolean | undefined, shouldValidate?: boolean | undefined) => void;
}

const CreateMappingFormFields: FC<FormFieldProps> = ({
  packageVersionUuid,
  errors,
  values,
  setFieldValue,
  setFieldTouched
}) => (
  <FlexLayout flexDirection="column">
    <Input
      autoFocus
      required
      label="Name"
      type="text"
      name="name"
      id="name"
      value={values.name}
      onBlur={() => setFieldTouched('name', true)}
      onChange={e => setFieldValue('name', e.target.value)}
      placeholder="Enter a mapping name"
      error={!!errors.name}
      helperText={errors.name}
      sx={{ marginY: 1 }}
    />

    <Input
      label="Description"
      type="text"
      name="description"
      id="description"
      value={values.description}
      onBlur={() => setFieldTouched('description', true)}
      onChange={e => setFieldValue('description', e.target.value)}
      placeholder="Enter a mapping description"
      error={!!errors.description}
      helperText={errors.description}
      sx={{ marginY: 1 }}
    />
    <StructurePicker
      packageVersionUuid={packageVersionUuid}
      helperText={errors.sourceModel as any}
      selectedValue={values.sourceModel}
      label="Source Structure"
      onChange={model => setFieldValue('sourceModel', model)}
    />

    <StructurePicker
      packageVersionUuid={packageVersionUuid}
      helperText={errors.targetModel as any}
      selectedValue={values.targetModel}
      label="Target Structure"
      onChange={model => setFieldValue('targetModel', model)}
    />
  </FlexLayout>
);

export default CreateMappingFormFields;
